import axios from "axios";
import { toast } from "react-toastify";
// const BASE_URL = 'https://xpansedev.theuplife.in/'

// <-------- Development URL --------> 
// const BASE_URL = 'https://xpanse.dev.bexcart.com/';

// <-------- Production URL -------->
// const BASE_URL = 'https://api.xpansecafe.com/';

// -----------> NEW PRODUCTION URL FOR ADMIN PANEL <-----------------
const BASE_URL = 'https://admin.api.xpansecafe.com/';

// Create axios instance
const axiosInstance = axios.create({
    baseURL: BASE_URL,
    timeout: 72000,
    // headers: {
    //     'Content-Type': 'application/json',
    // }
});

// State management
const authState = {
    hasShownExpiredToast: false,
    isRedirecting: false
};

// Helper functions
const AuthHelper = {
    clearAuthData() {
        const items = ["authToken", "email", "userRole", "userId", "access", "user"];
        items.forEach(item => localStorage.removeItem(item));
    },

    redirectToLogin() {
        if (authState.isRedirecting) return;

        authState.isRedirecting = true;

        if (!authState.hasShownExpiredToast) {
            toast.error("Session expired. Please login again.", {
                position: "top-right",
                autoClose: 2500,
            });
            authState.hasShownExpiredToast = true;
        }

        this.clearAuthData();

        setTimeout(() => {
            if (window.location.pathname !== '/') {
                window.location.href = '/';
            }
        }, 500);
    },

    validateToken(token) {
        if (!token || typeof token !== 'string' || token.trim() === '') {
            return false;
        }

        const parts = token.split('.');
        if (parts.length !== 3) {
            return false;
        }

        try {
            const payload = JSON.parse(atob(parts[1]));
            if (payload.exp && Date.now() >= payload.exp * 1000) {
                return false;
            }
            return true;
        } catch {
            return false;
        }
    },

    isTokenError(message) {
        if (!message) return false;
        const msg = String(message).toLowerCase();
        const keywords = ['jwt', 'token', 'malformed', 'invalid', 'expired', 'unauthorized'];
        return keywords.some(keyword => msg.includes(keyword));
    }
};

// Request Interceptor
axiosInstance.interceptors.request.use(
    (config) => {
        // Reset state for new request
        authState.hasShownExpiredToast = false;
        authState.isRedirecting = false;

        const token = localStorage.getItem("authToken");

        if (token && AuthHelper.validateToken(token)) {
            config.headers.Authorization = `Bearer ${token}`;
        } else if (token) {
            console.warn('Invalid token detected, skipping Authorization header');
        }

        return config;
    },
    (error) => Promise.reject(error)
);

// Response Interceptor
axiosInstance.interceptors.response.use(
    (response) => {
        // 🚨 Only logout if backend EXPLICITLY says auth failed
        if (
            response.status === 401
            //   ||
            //   response.status === 403
        ) {
            AuthHelper.redirectToLogin();
            return Promise.reject(new Error("Authentication error"));
        }

        return response;
    },
    (error) => {
        const { response, code, message } = error;

        // 🌐 Network errors
        if (!response) {
            if (code === "ECONNABORTED") {
                toast.error("Request timeout. Please try again.");
            } else if (message === "Network Error") {
                toast.error("Network error. Please check your connection.");
            }
            return Promise.reject(error);
        }

        const { status, data } = response;

        // 🔐 AUTH errors ONLY
        if (status === 401) {
            AuthHelper.redirectToLogin();
            return Promise.reject(new Error("Authentication error"));
        }

        // ⚠ Business / validation errors (400, 422, etc.)
        if (status === 400 || status === 422) {
            if (data?.message) {
                toast.error(data.message);
            }
            return Promise.reject(error);
        }

        // 💥 Server errors
        if (status >= 500) {
            toast.error("Server error. Please try again later.");
        }

        return Promise.reject(error);
    }
);

// axiosInstance.interceptors.response.use(
//   (response) => {
//     // Case: backend sends status=false with token error message
//     if (
//       response.data?.status === false &&
//       AuthHelper.isTokenError(response.data?.message)
//     ) {
//       AuthHelper.redirectToLogin();
//       return Promise.reject(new Error("Token error"));
//     }

//     return response;
//   },
//   (error) => {
//     const { response, code, message } = error;

//     // 🌐 Network errors (no server response)
//     if (!response) {
//       if (code === "ECONNABORTED") {
//         toast.error("Request timeout. Please try again.");
//       } else if (message === "Network Error") {
//         toast.error("Network error. Please check your connection.");
//       }
//       return Promise.reject(error);
//     }

//     const { status, data } = response;

//     // 🔐 Logout ONLY when token is invalid/expired
//     if (
//       status === 401 ||
//       AuthHelper.isTokenError(data?.message)
//     ) {
//       AuthHelper.redirectToLogin();
//       return Promise.reject(new Error("Authentication error"));
//     }

//     // ⚠ Other API errors (NO logout)
//     if (status >= 400 && data?.message && status !== 404) {
//       toast.error(data.message);
//     } else if (status >= 500) {
//       toast.error("Server error. Please try again later.");
//     }

//     return Promise.reject(error);
//   }
// );


export default axiosInstance;


// export default axios.create({
//     baseURL: BASE_URL,
// })